import * as React from 'react';
import styled from "styled-components";

const ImprintComponent = (props: any) => (
    <div className={props.className}>
            <a href={"https://www.sipgate.de/impressum"} target="_blank">Impressum</a>
    </div>
);

export default styled(ImprintComponent)`
  display: flex;
  padding: 0 24px 0 24px;
  margin-bottom: 8px;

  a {
    text-decoration: none;
    color: white;
    margin-left: auto;
  }
  
  a:hover {
    text-decoration: underline;
  }
`



// WEBPACK FOOTER //
// ./src/components/ImprintComponent.tsx